import './index.css'
import {Component} from 'react'
import Cookies from 'js-cookie'
import {Redirect} from 'react-router-dom'
import Loader from 'react-loader-spinner'
import {formatDistanceToNow} from 'date-fns'
import ReactPlayer from 'react-player'

import {BiLike, BiDislike, BiListPlus} from 'react-icons/bi'
import LeftPortion from '../LeftPortion'
import ThemeContext from '../ThemeContext'
import Header from '../Header'

const apiStatus = {
  initial: 'INITIAL',
  loading: 'LOADING',
  success: 'SUCCESS',
  failure: 'FAILURE',
}

const likeStatus = {
  like: 'LIKE',
  dislike: 'DISLIKE',
  none: 'NONE',
}

class VideoItemDetails extends Component {
  state = {
    videoDetails: {},
    currentLikeStatus: likeStatus.none,
    fetchStatus: apiStatus.initial,
  }

  componentDidMount() {
    this.getVideoData()
  }

  getVideoData = async () => {
    this.setState({fetchStatus: apiStatus.loading})
    const {match} = this.props
    const {id} = match.params
    const url = `https://apis.ccbp.in/videos/${id}`
    const jwtToken = Cookies.get('jwt_token')
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }

    const response = await fetch(url, options)
    if (response.ok) {
      const data = await response.json()
      const formattedData = {
        id: data.video_details.id,
        title: data.video_details.title,
        thumbnailUrl: data.video_details.thumbnail_url,
        viewCount: data.video_details.view_count,
        publishedAt: data.video_details.published_at,
        description: data.video_details.description,
        videoUrl: data.video_details.video_url,
        channel: {
          name: data.video_details.channel.name,
          profileImageUrl: data.video_details.channel.profile_image_url,
          subscriberCount: data.video_details.channel.subscriber_count,
        },
      }
      this.setState({
        videoDetails: formattedData,
        fetchStatus: apiStatus.success,
      })
    } else {
      this.setState({fetchStatus: apiStatus.failure})
    }
  }

  handleRetry = () => {
    this.getVideoData()
  }

  toggleLike = () => {
    this.setState(prevState => ({
      currentLikeStatus:
        prevState.currentLikeStatus === likeStatus.like
          ? likeStatus.none
          : likeStatus.like,
    }))
  }

  toggleDislike = () => {
    this.setState(prevState => ({
      currentLikeStatus:
        prevState.currentLikeStatus === likeStatus.dislike
          ? likeStatus.none
          : likeStatus.dislike,
    }))
  }

  renderLoadingView = () => (
    <div className="loader-container" data-testid="loader">
      <Loader type="ThreeDots" color="#4f46e5" height="50" width="50" />
    </div>
  )

  renderSuccessView = (toSaveVideo, savedVideos, activeThemeIsLight) => {
    const {videoDetails, currentLikeStatus} = this.state
    const {channel} = videoDetails

    const handleSave = () => {
      toSaveVideo(videoDetails)
    }

    const isSaved = savedVideos.some(each => each.id === videoDetails.id)
    const publishedDate = formatDistanceToNow(
      new Date(videoDetails.publishedAt),
    )

    return (
      <div className="video_detail_div">
        <div className="video_detail_div_a">
          <div className="player-wrapper">
            <ReactPlayer
              className="react-player"
              url={videoDetails.videoUrl}
              width="100%"
              height="100%"
              controls
            />
          </div>
        </div>

        <div className="video_detail_div_b">
          <h1 className="video-title">{videoDetails.title}</h1>

          <div className="video_detail_div_b_a">
            <div className="video_detail_div_b_a_a">
              <p>{videoDetails.viewCount} views</p>
              <p className="dot-separator">•</p>
              <p>{publishedDate} ago</p>
            </div>

            <div className="video_detail_div_b_a_b">
              <button
                type="button"
                onClick={this.toggleLike}
                className={`action-button ${
                  currentLikeStatus === likeStatus.like ? 'active' : ''
                }`}
              >
                <BiLike size={20} />
                Like
              </button>

              <button
                type="button"
                onClick={this.toggleDislike}
                className={`action-button ${
                  currentLikeStatus === likeStatus.dislike ? 'active' : ''
                }`}
              >
                <BiDislike size={20} />
                Dislike
              </button>

              <button
                type="button"
                onClick={handleSave}
                className={`action-button ${isSaved ? 'active' : ''}`}
              >
                <BiListPlus size={20} />
                {isSaved ? 'Saved' : 'Save'}
              </button>
            </div>
          </div>

          <hr className="separator" />

          <div className="video_detail_div_b_b">
            <img
              src={channel.profileImageUrl}
              alt={channel.name} // Added alt text for accessibility
              className="thumbnails"
            />
            <div className="video_detail_div_b_b_a">
              <p className="h_v">{channel.name}</p>
              <p className="p_v">{channel.subscriberCount} subscribers</p>
              <p className="p_v_a">{videoDetails.description}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderFailureView = () => (
    <div className="failure_view">
      <img
        className="failure_image"
        src="https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-light-theme-img.png"
        alt="failure view"
      />
      <h1>Oops! Something Went Wrong</h1>
      <p>
        We are having some trouble completing your request. Please try again.
      </p>
      <button className="retry_button" type="button" onClick={this.handleRetry}>
        Retry
      </button>
    </div>
  )

  renderApiStatusView = (toSaveVideo, savedVideos, activeThemeIsLight) => {
    const {fetchStatus} = this.state
    switch (fetchStatus) {
      case apiStatus.loading:
        return this.renderLoadingView()
      case apiStatus.success:
        return this.renderSuccessView(
          toSaveVideo,
          savedVideos,
          activeThemeIsLight,
        )
      case apiStatus.failure:
        return this.renderFailureView()
      default:
        return null
    }
  }

  render() {
    const token = Cookies.get('jwt_token')
    if (token === undefined) {
      return <Redirect to="/login" />
    }

    return (
      <ThemeContext.Consumer>
        {value => {
          const {activeThemeIsLight, savedVideos, toSaveVideo} = value
          const themeClass = activeThemeIsLight ? 'light-theme' : 'dark-theme'

          return (
            <>
              <Header />
              <div
                className="video-item-details-container"
                data-testid="videoItemDetails"
              >
                <LeftPortion />
                <div className={`content-container ${themeClass}`}>
                  {this.renderApiStatusView(
                    toSaveVideo,
                    savedVideos,
                    activeThemeIsLight,
                  )}
                </div>
              </div>
            </>
          )
        }}
      </ThemeContext.Consumer>
    )
  }
}

export default VideoItemDetails
